<template>
<div class="chapter">
<div class="inner_page">
<a id="p2"></a>
<p class="sink"> </p>
<blockquote>
<p class="right "><em>for Owen and Olanne</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?1e7ea50c